import oRequest from '@/libsV2/request.js';

const URL = {
    REFER_ADD: 'discuss.index/refer_add',//我要推荐
    REFER_LIST: 'discuss.index/refer_list',//我要推荐列表
    REFER_DETAIL: 'discuss.index/refer_onle',//我要推荐列表
}

export default {
    getReferAdd(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.REFER_ADD, oData)
    },
    getReferList(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.REFER_LIST, oData)
    },
    getReferDetail(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.REFER_DETAIL, oData)
    },
}